import React from 'react'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import { observer } from 'mobx-react'
import SelectCustom from '../../../../ContentBox/Global/Select/SelectCustom'

const ReasonRejectModal = () => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore

  return (
    <FormField>
      <FormLabel>{'Reason for refusal'}:</FormLabel>
      <SelectCustom
        placeholder={'Reason for refusal'}
        apiLinkCRM={'settings/project_settings/deal_reject_reason_choices'}
        apiGetResult={(result) => result.value.choices}
        valueID={modalValue.reject_reason}
        optionLabelKey='name'
        optionValueKey='name'
        onChange={(level) => changeValues(level.name, 'reject_reason')}
        isSearchable
        error={check('reject_reason')}
      />
    </FormField>
  )
}

export default observer(ReasonRejectModal)
